<template>
  <div class="col-sm-12 padding-zero">
    <div class="form-body success-body col-md-8 col-12">
      <v-col cols="12" class="padding-zero">
        <img src="@/assets/images/tick.png" class="img-responsive" />
      </v-col>
      <v-col cols="12" class="padding-zero m-t-10">
        <h2>YachtCover proposal form submitted</h2>
      </v-col>
      <v-col cols="12" class="padding-zero m-t-20">
        <div class="ref-div">
          Ref Number:
          <span class="ref-no"> {{ $store.state.submissionId }}</span>
        </div>
      </v-col>

      <v-row class="form-item-section">
        <v-col cols="12" sm="12" md="12" class="success-details">
          <h4>Your details</h4>
          <div class="info-div col-12">
            <span class="title">Name of yacht owner</span>
            <span class="answer">{{ formDetails.proposer_detail.name }}</span>
          </div>
          <div class="info-div col-12">
            <span class="title">Phone number and email</span>
            <span class="answer">
              +{{ formDetails.proposer_detail.phone_country_code }}
              {{ formDetails.proposer_detail.phone }} |
              {{ formDetails.proposer_detail.email }}
            </span>
          </div>
          <div class="info-div col-12">
            <span class="title">Name of yacht</span>
            <span class="answer">{{ formDetails.yacht_detail.name }}</span>
          </div>
          <div class="info-div col-12">
            <span class="title">Proposed policy period</span>
            <span class="answer">
              {{
                formDetails.policy_detail.proposed_insurance_inception_date
                  | moment
              }}
              -
              {{
                formatDate(
                  formDetails.policy_detail.proposed_insurance_inception_date
                ) | moment
              }}
            </span>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="12" class="success-details m-t-20">
          <h4>Next Steps</h4>
          <div class="info-div m-b-0">
            <span class="black"
              >1. Your application details will be shared with Insurers.</span
            >
            <span class="black"
              >2. One of our yacht specialists will contact you by telephone or
              email with your quotation within 1-2 business days.</span
            >
            <span class="black"
              >3. If you require any modifications to the application details or
              need to speak to a yacht specialist, please contact us at
            </span>
            <div class="icon-span">
              <div class="phone-icon"></div>
              <span :lang="getLang" v-html="$t('lang.success.phone')"></span>
            </div>
            <div class="icon-span">
              <div class="email-icon"></div>
              <span>yachtcover@marsh.com</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-col
      cols="12"
      class="button-container col-md-8"
    >
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#0080B4"
        @click="goHome"
      >
        <span class="home-icon"></span>
        Return Home
      </v-btn>
    </v-col>
  </div>
</template>

<script>
import moment from "moment";
import PremiumApi from "@/plugins/axios";

export default {
  name: "Success",
  data() {
    return {
      formDetails: this.getFormDetails(),
    };
  },
  filters: {
    moment: function(date) {
      var result = moment(date).format("DD/MM/YY");
      if (result === "Invalid date") {
        return "";
      } else {
        return moment(date).format("DD/MM/YYYY");
      }
    },
  },
  methods: {
    goHome: function() {
      const policyDetails = _.cloneDeep(this.$store.getters.getPolicyDetails);
      policyDetails.is_cover_sails = "N";
      policyDetails.cover_sails_replacement_value = null;
      policyDetails.is_cover_sports = "N";
      policyDetails.cover_sports_type = null;
      policyDetails.limit_liability = null;
      policyDetails.is_additional_cover_required = "N";
      this.$store.commit("savePolicyDetails", policyDetails);
      this.$store.state.formPageNumber=0;
    },
    getFormDetails: function() {
      return _.cloneDeep(this.$store.getters.getFormDetails);
    },
    moment: function(e) {
      return moment();
    },
    formatDate: function(date) {
      var currentDate = moment(date);
      return moment(currentDate)
        .add(1, "Y")
        .subtract(1, "minutes");
    },
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + "/Success";
      PremiumApi.logAccess(postData, function(data) {
        console.log("Data sent with : " + JSON.stringify(postData));
      });
    },
  },
  mounted: function() {
    window.scrollTo(0, 0);
    this.trackPage();
  },
  computed: {
    getLang() {
      //return this.$store.state.country === "hk" ? "hk" : "sg";
      if(this.$store.state.country === "hk"){
        return "hk";
      }else if(this.$store.state.country === "th"){
        return "th";
      }else {
        return "sg";
      }
    },
  },
};
</script>

